/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartItemOptionDto } from './CartItemOptionDto';
import {
    CartItemOptionDtoFromJSON,
    CartItemOptionDtoFromJSONTyped,
    CartItemOptionDtoToJSON,
} from './CartItemOptionDto';

/**
 * 
 * @export
 * @interface CartItemDto
 */
export interface CartItemDto {
    /**
     * 
     * @type {string}
     * @memberof CartItemDto
     */
    itemVariantId: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDto
     */
    menuSectionId: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDto
     */
    sectionProductId: string;
    /**
     * 
     * @type {number}
     * @memberof CartItemDto
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemDto
     */
    quantity: number;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemDto
     */
    openPrice: boolean;
    /**
     * 
     * @type {string}
     * @memberof CartItemDto
     */
    deliveryType: CartItemDtoDeliveryTypeEnum;
    /**
     * 
     * @type {Array<CartItemOptionDto>}
     * @memberof CartItemDto
     */
    options: Array<CartItemOptionDto>;
    /**
     * 
     * @type {string}
     * @memberof CartItemDto
     */
    emailRecipients?: string;
}


/**
 * @export
 */
export const CartItemDtoDeliveryTypeEnum = {
    TABLE: 'TABLE',
    PICKUP: 'PICKUP',
    TAKEAWAY: 'TAKEAWAY',
    ROOM_SERVICE: 'ROOM_SERVICE',
    HOME_DELIVERY: 'HOME_DELIVERY',
    SEAT: 'SEAT',
    ROOM: 'ROOM',
    COUNTER: 'COUNTER',
    ONLINE: 'ONLINE'
} as const;
export type CartItemDtoDeliveryTypeEnum = typeof CartItemDtoDeliveryTypeEnum[keyof typeof CartItemDtoDeliveryTypeEnum];


/**
 * Check if a given object implements the CartItemDto interface.
 */
export function instanceOfCartItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "itemVariantId" in value;
    isInstance = isInstance && "menuSectionId" in value;
    isInstance = isInstance && "sectionProductId" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "openPrice" in value;
    isInstance = isInstance && "deliveryType" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function CartItemDtoFromJSON(json: any): CartItemDto {
    return CartItemDtoFromJSONTyped(json, false);
}

export function CartItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'itemVariantId': json['itemVariantId'],
        'menuSectionId': json['menuSectionId'],
        'sectionProductId': json['sectionProductId'],
        'price': json['price'],
        'quantity': json['quantity'],
        'openPrice': json['openPrice'],
        'deliveryType': json['deliveryType'],
        'options': ((json['options'] as Array<any>).map(CartItemOptionDtoFromJSON)),
        'emailRecipients': !exists(json, 'emailRecipients') ? undefined : json['emailRecipients'],
    };
}

export function CartItemDtoToJSON(value?: CartItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'itemVariantId': value.itemVariantId,
        'menuSectionId': value.menuSectionId,
        'sectionProductId': value.sectionProductId,
        'price': value.price,
        'quantity': value.quantity,
        'openPrice': value.openPrice,
        'deliveryType': value.deliveryType,
        'options': ((value.options as Array<any>).map(CartItemOptionDtoToJSON)),
        'emailRecipients': value.emailRecipients,
    };
}

